<template lang="pug">
div
  .text-2xl.font-semibold.mb-2 {{ ridTitle }} &#35;{{ rid }}
  .text-xs.mb-2 Updated by:
  .d-flex.align-center.mb-2
    v-icon.mr-2(size="15") $yzi-user-02
    .text-xs {{ updatedBy }}
  .d-flex.align-center.mb-2
    v-tooltip(top color="black")
      template(#activator="{ on, attrs }")
        div.d-flex.align-center(v-bind="attrs" v-on="on")
          v-icon.mr-2(size="15") $yzi-calendar
          .text-xs.capitalize {{ updatedDate | convertToRelativeCalendar }}
      div.py-1
        div.text-xs {{ updatedFormattedDate }}
  .d-flex.align-center.mb-2
    v-icon.mr-2(size="15") $yzi-clock
    .text-xs {{ updatedTime }}
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    parentData: {
      type: Object,
      default: null
    },
    selectedDocument: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasParentData () {
      return !!this.parentData
    },
    rid () {
      return this.parentData?.rid
    },
    updatedBy () {
      if (!this.hasParentData) return ''
      return `${this.parentData.updated_by?.first_name} ${this.parentData.updated_by?.last_name}`
    },
    updatedDate () {
      if (!this.hasParentData) return ''
      return this.parentData.updated_at
    },
    updatedFormattedDate () {
      if (!this.hasParentData) return ''
      const dateFormat = 'dd MMM yyyy'
      const datetime = DateTime.fromISO(this.parentData.updated_at)
      return datetime.toFormat(dateFormat)
    },
    updatedTime () {
      if (!this.hasParentData) return ''
      const datetime = DateTime.fromISO(this.parentData.updated_at)
      return datetime.toFormat('hh:mm a')
    },
    ridTitle () {
      switch (this.selectedDocument.id) {
        case 'quotation':
          return 'Quotation'

        case 'purchase-order':
          return 'PO'

        case 'invoice':
          return 'INV'

        case 'stock-transfer':
          return 'TRANSFER'
      
        default:
          return ''
      }
    }
  },
}
</script>

<style scoped>
</style>